export const API_ENDPOINT = {
   BASE_URL:'https://app.easyappear.it/webservice'
}

export const API_PATH = {
   SMARTCARD_SET_CUSTOMER: 'smartcard_set_customer',
   GET_APP_BY_REFERENCE: 'get_app_by_reference',
   GET_CUSTOMER: 'get_customer',
   GET_PAGES: 'get_pages',

   GET_COMUNI: 'get_comuni',
   
   EASYPOS:'easypos'
}


export const LOCAL_STORAGE_KEYS = {
   LANGUAGE: '__smart_card_language',
   REFERENCE: '__smart_card_reference'
}

export const APP_ROUTES_PATH = {
   SMART_CARD:'/smart_card',
   REGISTER:'/register',
   LOGIN:'/login',
   NOT_FOUND:'/404',
}

const WIDGET_PREFIX = 'widget://smartcard_'
export const APP_CUSTOM_WIDGETS = {
   SMARTCARD_REGISTRATI: `${WIDGET_PREFIX}registrati`,
   SMARTCARD_ACCEDI: `${WIDGET_PREFIX}accedi`,
   SMARTCARD_FIDELITY: `${WIDGET_PREFIX}fidelity`,
}

export const APP_WIDGETS = {
   ACCEDI: 'accedi',
   REGISTRATI: 'registrati',
   CONTO: 'conto',
}

export const WHITE_LABEL_TENANT = {
   XERJOFF: {
      REFERENCE: 'xerjoff',
      COLOR:'#000000'
   },
   PIAZZA_AFFARI: {
      REFERENCE:'piazzaaffari'
   }
}
